import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.unshift.js";
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2e5e0957"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "out-box"
};
const _hoisted_2 = {
  class: "content-box"
};
const _hoisted_3 = {
  key: 0,
  style: {
    "display": "flex",
    "flex": "1",
    "flex-direction": "column"
  }
};
const _hoisted_4 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "align-items": "center",
    "margin-left": "16px",
    "margin-bottom": "16px"
  }
};
const _hoisted_5 = {
  style: {
    "display": "flex",
    "flex": "1"
  }
};
const _hoisted_6 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "width": "620px",
    "box-shadow": "0px 0px 10px 0px #f7f8ff",
    "background": "#fff",
    "margin": "0px 16px 16px 16px"
  }
};
const _hoisted_7 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "margin": "16px 0px 0px 16px",
    "color": "rgba(35, 35, 35, 1)"
  }
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "活动参与度", -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "flex": "1"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "flex": "1",
    "margin": "16px"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "display": "flex",
    "height": "20px",
    "font-size": "12px",
    "color": "#000",
    "line-height": "20px",
    "align-items": "center"
  }
}, [/*#__PURE__*/_createElementVNode("div", null, "数量(个)"), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "flex": "1"
  }
}), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "12px",
    "height": "12px",
    "margin-right": "5px",
    "background": "linear-gradient(\n                              to top,\n                              rgba(47, 95, 254, 1),\n                              rgba(181, 198, 255, 1)\n                            )"
  }
}), /*#__PURE__*/_createElementVNode("div", null, "整体店铺参与度")]), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "flex": "1",
    "position": "relative"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  id: "containerStore",
  style: {
    "position": "absolute",
    "inset": "0px"
  }
})])]), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "flex": "1",
    "margin": "16px"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "display": "flex",
    "height": "20px",
    "font-size": "12px",
    "color": "#000",
    "line-height": "20px",
    "align-items": "center"
  }
}, [/*#__PURE__*/_createElementVNode("div", null, "数量(个)"), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "flex": "1"
  }
}), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "12px",
    "height": "12px",
    "margin-right": "5px",
    "background": "linear-gradient(\n                              to top,\n                              rgba(155, 239, 175, 1),\n                              rgba(44, 187, 93, 1)\n                            )"
  }
}), /*#__PURE__*/_createElementVNode("div", null, "整体点位参与度")]), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "flex": "1",
    "position": "relative"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  id: "containerStoreLocation",
  style: {
    "position": "absolute",
    "inset": "0px"
  }
})])])], -1));
const _hoisted_10 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "flex": "1",
    "background-color": "white",
    "box-shadow": "0px 0px 10px 0px #f7f8ff"
  }
};
const _hoisted_11 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "margin": "16px 0px 0px 16px",
    "color": "rgba(35, 35, 35, 1)"
  }
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "店铺数据分析", -1));
const _hoisted_13 = {
  style: {
    "height": "150px",
    "margin": "15px",
    "display": "flex",
    "align-items": "center",
    "flex-direction": "column",
    "border-radius": "10px",
    "border": "solid 1px rgba(215, 212, 212, 1)",
    "position": "relative"
  }
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "margin": "15px 0px 2px 0px",
    "font-size": "13px",
    "color": "rgba(59, 113, 184, 1)"
  }
}, " 店铺类型数量统计 ", -1));
const _hoisted_15 = {
  style: {
    "display": "flex",
    "width": "100%",
    "position": "relative"
  }
};
const _hoisted_16 = {
  style: {
    "display": "flex",
    "position": "absolute",
    "left": "0px",
    "right": "0px",
    "padding-bottom": "10px",
    "overflow-x": "auto"
  }
};
const _hoisted_17 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "align-items": "center",
    "margin": "15px 15px 10px 15px"
  }
};
const _hoisted_18 = {
  style: {
    "font-size": "36px",
    "color": "rgba(59, 113, 184, 1)"
  }
};
const _hoisted_19 = {
  style: {
    "font-size": "12px",
    "color": "#2ecee7"
  }
};
const _hoisted_20 = {
  style: {
    "font-size": "14px",
    "color": "#3b71b8",
    "margin-top": "10px"
  }
};
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "position": "absolute",
    "left": "15px",
    "right": "15px",
    "top": "102px",
    "height": "1px",
    "background-color": "rgba(59, 113, 184, 1)"
  }
}, null, -1));
const _hoisted_22 = {
  style: {
    "flex": "1",
    "margin-left": "15px",
    "margin-right": "15px",
    "display": "flex"
  }
};
const _hoisted_23 = {
  style: {
    "flex": "1",
    "border-radius": "10px",
    "border": "1px solid rgb(215, 212, 212)",
    "margin-right": "15px",
    "display": "flex",
    "flex-direction": "column",
    "align-items": "center",
    "margin-bottom": "10px"
  }
};
const _hoisted_24 = {
  style: {
    "color": "#3b71b8",
    "font-size": "36px",
    "margin-top": "10px"
  }
};
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "height": "1px",
    "width": "200px",
    "background-color": "#3b71b8",
    "margin": "10px 0px"
  }
}, null, -1));
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "color": "#3b71b8",
    "font-size": "13px",
    "margin-bottom": "10px"
  }
}, " 参与活动数量≥4次/年 ", -1));
const _hoisted_27 = {
  style: {
    "display": "flex",
    "font-size": "12px",
    "margin-bottom": "10px"
  }
};
const _hoisted_28 = {
  style: {
    "flex": "1",
    "width": "100%",
    "position": "relative"
  }
};
const _hoisted_29 = {
  style: {
    "position": "absolute",
    "inset": "0",
    "overflow-y": "auto",
    "display": "flex",
    "flex-direction": "column",
    "margin": "0px 10px"
  }
};
const _hoisted_30 = {
  style: {
    "white-space": "nowrap",
    "overflow": "hidden",
    "text-overflow": "ellipsis"
  }
};
const _hoisted_31 = {
  style: {
    "margin-left": "auto"
  }
};
const _hoisted_32 = {
  style: {
    "width": "400px",
    "border-radius": "10px",
    "border": "1px solid rgb(215, 212, 212)",
    "display": "flex",
    "flex-direction": "column",
    "align-items": "center",
    "margin-bottom": "10px"
  }
};
const _hoisted_33 = {
  style: {
    "color": "#3b71b8",
    "font-size": "36px",
    "margin-top": "10px"
  }
};
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "height": "1px",
    "width": "200px",
    "background-color": "#3b71b8",
    "margin": "10px 0px"
  }
}, null, -1));
const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "color": "#3b71b8",
    "font-size": "13px",
    "margin-bottom": "10px"
  }
}, " 参与活动数量<4次/年 ", -1));
const _hoisted_36 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "flex": "1",
    "width": "100%",
    "position": "relative"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  id: "lessThan4Content",
  style: {
    "position": "absolute",
    "inset": "0px"
  }
})], -1));
const _hoisted_37 = {
  key: 0,
  style: {
    "display": "flex",
    "flex": "1",
    "flex-direction": "column",
    "overflow": "hidden"
  }
};
const _hoisted_38 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "align-items": "center",
    "margin-left": "16px",
    "margin-bottom": "16px"
  }
};
const _hoisted_39 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "margin-left": "16px",
    "margin-bottom": "16px",
    "height": "200px"
  }
};
const _hoisted_40 = {
  style: {
    "width": "400px",
    "display": "flex",
    "flex-direction": "column"
  }
};
const _hoisted_41 = {
  style: {
    "display": "flex",
    "font-size": "12px",
    "margin-bottom": "10px"
  }
};
const _hoisted_42 = ["onClick"];
const _hoisted_43 = {
  style: {
    "display": "flex",
    "font-size": "12px",
    "margin-bottom": "10px",
    "position": "relative",
    "overflow-x": "auto",
    "overflow-y": "hidden",
    "height": "40px"
  }
};
const _hoisted_44 = {
  style: {
    "display": "flex",
    "position": "absolute",
    "inset": "0px"
  }
};
const _hoisted_45 = ["onClick"];
const _hoisted_46 = {
  style: {
    "display": "flex",
    "font-size": "12px",
    "margin-bottom": "10px",
    "position": "relative",
    "overflow-x": "auto",
    "overflow-y": "hidden",
    "height": "40px"
  }
};
const _hoisted_47 = {
  style: {
    "display": "flex",
    "position": "absolute",
    "inset": "0px"
  }
};
const _hoisted_48 = ["onClick"];
const _hoisted_49 = {
  key: 0,
  style: {
    "flex": "1",
    "display": "flex",
    "height": "185px"
  }
};
const _hoisted_50 = ["src"];
const _hoisted_51 = {
  style: {
    "margin": "0px 15px",
    "flex": "1",
    "display": "flex",
    "flex-direction": "column"
  }
};
const _hoisted_52 = {
  style: {
    "margin": "10px 0",
    "display": "flex",
    "justify-content": "space-between",
    "align-items": "center",
    "cursor": "pointer"
  }
};
const _hoisted_53 = {
  style: {
    "font-size": "32px",
    "color": "black",
    "font-family": "'NIKE_FUTURA_CN-XB'",
    "word-break": "break-all"
  }
};
const _hoisted_54 = {
  style: {
    "font-size": "16px",
    "color": "#777",
    "margin-bottom": "10px"
  }
};
const _hoisted_55 = {
  style: {
    "display": "flex",
    "justify-content": "space-between",
    "color": "#777",
    "font-size": "12px",
    "margin-top": "10px"
  }
};
const _hoisted_56 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "margin-right": "10px"
  }
}, "Notes:", -1));
const _hoisted_57 = {
  style: {
    "flex": "1"
  }
};
const _hoisted_58 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "flex": "1",
    "position": "relative"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  id: "storeActivityContainer",
  style: {
    "position": "absolute",
    "top": "0px",
    "left": "0px",
    "bottom": "0px",
    "right": "30px"
  }
})], -1));
const _hoisted_59 = {
  key: 0,
  style: {
    "display": "flex",
    "flex": "1",
    "flex-direction": "column",
    "overflow": "hidden"
  }
};
const _hoisted_60 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "margin": "0px 0px 0px 16px",
    "color": "rgba(35, 35, 35, 1)"
  }
};
const _hoisted_61 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "margin": "16px 0px 0px 16px",
    "color": "rgba(35, 35, 35, 1)"
  }
};
const _hoisted_62 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "供应商完成率", -1));
const _hoisted_63 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "display": "flex",
    "align-items": "center",
    "margin": "16px 0px 0px 16px",
    "color": "#333333",
    "font-size": "12px",
    "gap": "10px"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "flex": "1",
    "margin-left": "20px"
  }
}, "运输完成率"), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "flex": "1"
  }
}, "安装完成率")], -1));
const _hoisted_64 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "height": "220px",
    "margin": "16px 16px 0px 16px",
    "display": "flex",
    "align-items": "end"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "flex": "1",
    "height": "220px",
    "display": "flex"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  id: "vendorCompleteLogistics",
  style: {
    "flex": "1"
  }
}), /*#__PURE__*/_createElementVNode("div", {
  id: "vendorCompleteInstall",
  style: {
    "flex": "1"
  }
})]), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "font-size": "12px"
  }
}, "月份")], -1));
const _hoisted_65 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "margin": "10px 0px 0px 16px",
    "color": "rgba(35, 35, 35, 1)"
  }
};
const _hoisted_66 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "供应商参与度", -1));
const _hoisted_67 = {
  style: {
    "display": "flex",
    "font-size": "12px",
    "margin-left": "20px"
  }
};
const _hoisted_68 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "flex": "1",
    "margin": "16px 16px 0px 16px",
    "display": "flex",
    "position": "relative"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "display": "flex",
    "width": "100%",
    "font-size": "18px",
    "color": "#777777"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "flex": "1",
    "text-align": "center"
  }
}, "画面供应商"), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "flex": "1",
    "text-align": "center"
  }
}, "道具供应商"), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "flex": "1",
    "text-align": "center"
  }
})]), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "inset": "0px",
    "position": "absolute",
    "display": "flex"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  id: "vendorImagery",
  style: {
    "flex": "1"
  }
}), /*#__PURE__*/_createElementVNode("div", {
  id: "vendorProps",
  style: {
    "flex": "1"
  }
}), /*#__PURE__*/_createElementVNode("div", {
  id: "vendorProgram",
  style: {
    "flex": "1"
  }
})])], -1));
const _hoisted_69 = {
  key: 0,
  style: {
    "display": "flex",
    "flex": "1",
    "flex-direction": "column",
    "overflow": "hidden",
    "padding": "0px 16px 0px 16px",
    "color": "#000",
    "min-width": "0",
    "min-height": "0"
  }
};
const _hoisted_70 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "color": "rgba(35, 35, 35, 1)"
  }
};
const _hoisted_71 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "display": "flex",
    "margin-top": "10px"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "flex": "1"
  }
}, "报修统计"), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "flex": "2",
    "margin-left": "60px",
    "font-size": "12px"
  }
}, " 总报修(次) ")], -1));
const _hoisted_72 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "display": "flex",
    "margin": "0px 0px 0px 16px",
    "color": "rgba(35, 35, 35, 1)",
    "flex": "2",
    "position": "relative"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "inset": "0px",
    "position": "absolute",
    "display": "flex"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  id: "pieRepairVendorCountContent",
  style: {
    "flex": "1",
    "min-width": "0"
  }
}), /*#__PURE__*/_createElementVNode("div", {
  id: "barRepairVendorCountContent",
  style: {
    "flex": "2",
    "min-width": "0"
  }
})])], -1));
const _hoisted_73 = {
  style: {
    "display": "flex",
    "margin": "0px 0px 0px 16px",
    "color": "rgba(35, 35, 35, 1)",
    "flex": "3",
    "position": "relative"
  }
};
const _hoisted_74 = {
  style: {
    "flex": "1",
    "overflow": "hidden",
    "margin-right": "10px",
    "margin-bottom": "10px",
    "box-shadow": "2px 0px 5px 0px #f7f8ff"
  }
};
const _hoisted_75 = {
  style: {
    "flex": "1",
    "overflow": "hidden",
    "margin-left": "10px",
    "margin-bottom": "10px",
    "box-shadow": "2px 0px 5px 0px #f7f8ff"
  }
};
import { ref, reactive, onMounted, getCurrentInstance, watch, nextTick, createVNode, h, computed, onBeforeUnmount } from "vue";
import util from "@/util/util";
import permission from "@/util/permission";
import { Modal, message, Divider, Button } from "ant-design-vue";
import { DownCircleOutlined, PlusOutlined, ExclamationCircleOutlined, CheckOutlined, EditOutlined, CloseOutlined } from "@ant-design/icons-vue";
import ResizePane from "@/components/ResizePane.vue";
import dayjs from "dayjs";
import { useRouter, useRoute, onBeforeRouteLeave } from "vue-router";
import showConfirmModal from "@/util//showConfirmModal";
import { VueCropper } from "vue-cropper";
import { genFileId } from "element-plus";
import axios from "axios";
import useClipboard from "vue-clipboard3";
import { Chart } from "@antv/g2";
import { useI18n } from "vue-i18n";

import { ElNotification } from 'element-plus/es';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/notification/style/css';
export default {
  __name: 'ActivityReport',
  setup(__props) {
    const {
      t,
      locale
    } = useI18n(); // 获取 locale 引用
    const {
      proxy
    } = getCurrentInstance();
    const {
      toClipboard
    } = useClipboard();
    const route = useRoute();
    const router = useRouter();
    const tokenData = util.getToken();
    const activeTabsKey = ref("1");
    const activityData = reactive({
      activityFormData: {
        activityCategoryId: 1,
        activityDateValue: null,
        storeTypeName: "All"
      },
      storeFormData: {
        activityDateValue: null
      },
      vendorFormData: {
        year: null,
        vendorTypeId: 1,
        vendorId: null
      },
      repairFormData: {
        year: null
      },
      activityStoreTypeCount: [],
      filterActivityStoreTypeCount: [],
      activityCategoryList: [],
      activityStoreRankCount: [],
      filterActivityStoreRankCount: [],
      storeTypeData: ["All"],
      yearOptions: [],
      vendorTypeVendorData: [],
      vendorData: [],
      activityVendorCountData: [],
      activityStoreMonthCountData: [],
      lt4: 0,
      gte4: 0
    });
    const storeTypeControl = reactive({
      filterStoreTypeFullData: [],
      storeTypeFullData: [],
      filterStoreTypeData: [],
      storeTypeData: [],
      filterStoreType: [],
      activityCategoryId: 1,
      selectedStoreTypeName: [],
      storeTypeIds: []
    });
    const initTab = reactive({
      activityInit: true,
      storeInit: false,
      vendorInit: false,
      repairInit: false
    });
    const selectedActivity = reactive({
      data: {}
    });
    const isTop50 = ref(true);
    const isVendorActivity = ref(true);
    const repairRank = reactive({
      repairStoreRank: [],
      repairVendorRank: []
    });
    const vendorTypeData = [{
      label: "画面",
      value: 1
    }, {
      label: "道具",
      value: 2
    }, {
      label: "互动程序",
      value: 4
    }];
    const data = [{
      date: "2007/4/28-1",
      close: 93.24
    }, {
      date: "2007/4/28-2",
      close: 95.35
    }, {
      date: "2007/4/28-3",
      close: 98.84
    }, {
      date: "2007/4/29-1",
      close: 99.92
    }, {
      date: "2007/4/30-1",
      close: 99.8
    }, {
      date: "2007/5/1-1",
      close: 99.47
    }, {
      date: "2007/5/1-2",
      close: 100.39
    }, {
      date: "2007/5/2-1",
      close: 100.4
    }, {
      date: "2007/5/3-1",
      close: 100.81
    }, {
      date: "2007/5/4-1",
      close: 103.92
    }];

    // 1. 预处理数据，计算x坐标
    const mainDates = [];
    const dateMap = {};

    // 统计主日期顺序和子点数量
    data.forEach(d => {
      const [mainDate] = d.date.split(/-/);
      if (!dateMap[mainDate]) {
        dateMap[mainDate] = {
          count: 0,
          index: mainDates.length
        };
        mainDates.push(mainDate);
      }
      dateMap[mainDate].count++;
    });

    // 计算每个点的x坐标
    const processedData = data.map(d => {
      const [mainDate, subId] = d.date.split(/-/);
      const {
        index,
        count
      } = dateMap[mainDate];
      const position = index + parseInt(subId) / (count + 1);
      return {
        ...d,
        xPos: position
      };
    });
    onMounted(async () => {
      let activityCategoryList = await getActivityCategory();
      if (activityCategoryList == null) {
        return;
      }
      activityData.activityCategoryList = activityCategoryList;
      let storeTypeList = await getStoreTypeNameDict();
      if (storeTypeList == null) {
        return;
      }
      activityData.storeTypeData.push(...storeTypeList);
      storeTypeControl.storeTypeData.push(...storeTypeList);
      storeTypeList = await getStoreType();
      if (storeTypeList == null) {
        return;
      }
      storeTypeControl.storeTypeFullData.push(...storeTypeList);
      changeActivity();
    });
    const getActivityCategory = async () => {
      return new Promise((resolve, reject) => {
        proxy.$api.activityRequest.getActivityCategory(true).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: t("activityCreate.fail"),
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    const getVendorTypeVendor = async () => {
      return new Promise((resolve, reject) => {
        proxy.$api.vendorRequest.getVendorTypeVendor(true).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: t("activityCreate.fail"),
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    const getActivityCount = async activityCountRO => {
      return new Promise((resolve, reject) => {
        proxy.$api.activityRequest.getActivityCount(activityCountRO).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: t("activityCreate.fail"),
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    const getActivityCountInRange1ToLessThan3Export = activityCountRO => {
      proxy.$api.activityRequest.getActivityCountInRange1ToLessThan3Export(activityCountRO).then(res => {}).catch(error => {
        ElNotification({
          title: t("activityDetail.error"),
          message: error,
          type: "error",
          duration: 3000
        });
      });
    };
    const getVendorCount = async vendorCountRO => {
      return new Promise((resolve, reject) => {
        proxy.$api.activityRequest.getVendorCount(vendorCountRO).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: t("activityCreate.fail"),
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    const getRepairVendorCount = async repairCountRO => {
      return new Promise((resolve, reject) => {
        proxy.$api.repairRequest.getRepairVendorCount(repairCountRO).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: t("activityCreate.fail"),
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    const getStoreTypeNameDict = async () => {
      return new Promise((resolve, reject) => {
        proxy.$api.storeRequest.getStoreTypeNameDict(true).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: "失败",
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    const getStoreType = async () => {
      return new Promise((resolve, reject) => {
        proxy.$api.storeRequest.getStoreType(true).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: t("installConvey.failure"),
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    const getActivityStoreMonthCount = async activityStoreMonthCountRO => {
      return new Promise((resolve, reject) => {
        proxy.$api.activityRequest.getActivityStoreMonthCount(activityStoreMonthCountRO).then(res => {
          resolve(res.result.data);
        }).catch(error => {
          if (error.code == "TOKEN_MISSING") {
            resolve(null);
          } else {
            ElNotification({
              title: t("activityCreate.fail"),
              message: error,
              type: "error",
              duration: 3000
            });
          }
        });
      });
    };
    const pickerChange = async () => {
      if (activityData.activityFormData.activityDateValue == null) {
        return;
      }
      let activityCountRO = {
        activityCategoryId: activityData.activityFormData.activityCategoryId,
        activityBegin: activityData.activityFormData.activityDateValue[0].format("YYYY-MM-DD"),
        activityEnd: activityData.activityFormData.activityDateValue[1].format("YYYY-MM-DD")
      };
      let activityCountVO = await getActivityCount(activityCountRO);
      activityData.activityStoreTypeCount = activityCountVO.activityStoreTypeCount;
      activityData.activityStoreRankCount = activityCountVO.activityStoreRankCount;
      filterTopRank();
      refreshStoreTypeCount();
      refreshLowActivityStore(activityCountVO.activityStoreRankCount);
      // 初始化图表实例
      const chartStore = new Chart({
        container: "containerStore",
        autoFit: true
      });
      // 声明可视化
      chartStore.interval() // 创建一个 Interval 标记
      .data(activityCountVO.activityStoreCount) // 绑定数据
      .encode("x", "month") // 编码 x 通道
      .encode("y", "quantity") // 编码 y 通道
      .encode("size", 24).axis("x", {
        labelFill: "black",
        labelFontSize: 10,
        title: null // 隐藏 X 轴标题
      }).axis("y", {
        labelFill: "black",
        labelFontSize: 10,
        title: null // 隐藏 Y 轴标题
      }).style("fill", "l(270) 0:rgba(47, 95, 254, 1) 1:rgba(181, 198, 255, 1)");
      // 渲染可视化
      try {
        chartStore.render();
      } catch (e) {
        console.log(e);
      }

      // 初始化图表实例
      const chartStoreLocation = new Chart({
        container: "containerStoreLocation",
        autoFit: true
      });
      // 声明可视化
      chartStoreLocation.interval() // 创建一个 Interval 标记
      .data(activityCountVO.activityStoreLocationCount) // 绑定数据
      .encode("x", "month") // 编码 x 通道
      .encode("y", "quantity") // 编码 y 通道
      .encode("size", 24).axis("x", {
        labelFill: "black",
        labelFontSize: 10,
        title: null,
        // 隐藏 Y 轴标题
        title: null // 隐藏 X 轴标题
      }).axis("y", {
        labelFill: "black",
        labelFontSize: 10,
        title: null // 隐藏 Y 轴标题
      }).style("fill", "l(270) 0:rgba(155, 239, 175, 1) 1:rgba(44, 187, 93, 1)");
      // 渲染可视化
      try {
        chartStoreLocation.render();
      } catch (e) {
        console.log(e);
      }
    };
    var hoverData;
    const changeTab = async value => {
      if (value === "1") {
        changeActivity();
      }
      if (value === "2") {
        // if (initTab.storeInit == false) {
        //   initTab.storeInit = true;
        // } else {
        //   return;
        // }
        changeStore();
      } else if (value === "3") {
        // if (initTab.vendorInit == false) {
        //   initTab.vendorInit = true;
        // } else {
        //   return;
        // }
        changeVendor();
      } else if (value === "4") {
        // if (initTab.repairInit == false) {
        //   initTab.repairInit = true;
        // } else {
        //   return;
        // }
        changeRepair();
      }
    };
    const changeActivity = async () => {
      let yearsArray = [];
      for (let i = 2024; i <= new Date().getFullYear(); i++) {
        yearsArray.push(i);
      }
      activityData.yearOptions = yearsArray.reverse();
      activityData.vendorFormData.year = activityData.yearOptions[1];
      activityData.repairFormData.year = activityData.yearOptions[1];
      let vendorTypeVendorList = await getVendorTypeVendor();
      if (vendorTypeVendorList == null) {
        return;
      }
      activityData.vendorTypeVendorData.push(...vendorTypeVendorList);
      await vendorTypeChange(1);
      if (Array.isArray(activityData.vendorData) && activityData.vendorData.length > 0) {
        activityData.vendorFormData.vendorId = activityData.vendorData[0].vendorId;
      }
      activityData.activityFormData.activityDateValue = [dayjs().subtract(1, "year"),
      // 开始时间：一年前
      dayjs() // 结束时间：当前时间
      ];

      activityData.storeFormData.activityDateValue = [dayjs().subtract(1, "year"),
      // 开始时间：一年前
      dayjs() // 结束时间：当前时间
      ];

      pickerChange();
    };
    const changeStore = async () => {
      if (activityData.storeFormData.activityDateValue == null) {
        return;
      }
      let activityStoreMonthCountRO = {
        activityCategoryId: storeTypeControl.activityCategoryId,
        activityBegin: activityData.storeFormData.activityDateValue[0].format("YYYY-MM-DD"),
        activityEnd: activityData.storeFormData.activityDateValue[1].format("YYYY-MM-DD")
      };
      let activityStoreMonthCountVO = await getActivityStoreMonthCount(activityStoreMonthCountRO);
      activityData.activityStoreMonthCountData.length = 0;
      activityData.activityStoreMonthCountData.push(...activityStoreMonthCountVO);
      debugger;
      await nextTick();
      storeTypeControl.filterStoreTypeFullData = storeTypeControl.storeTypeFullData.filter(item => activityStoreMonthCountVO.some(a => a.storeTypeNameZh === item.storeTypeNameZh));
      storeTypeControl.filterStoreTypeData = storeTypeControl.storeTypeData.filter(item => storeTypeControl.filterStoreTypeFullData.some(a => a.storeTypeName === item));
      storeTypeControl.selectedStoreTypeName = [];
      storeTypeControl.selectedStoreTypeName.push(storeTypeControl.filterStoreTypeData[0]);
      storeTypeControl.filterStoreType.length = 0;
      for (let storeType of storeTypeControl.filterStoreTypeFullData) {
        if (storeTypeControl.selectedStoreTypeName.includes(storeType.storeTypeName)) {
          storeTypeControl.filterStoreType.push(storeType);
        }
      }
      storeTypeControl.storeTypeIds.length = 0;
      if (Array.isArray(storeTypeControl.filterStoreType) && storeTypeControl.filterStoreType.length > 0) {
        storeTypeControl.storeTypeIds.push(storeTypeControl.filterStoreType[0].storeTypeId);
      }
      activityStoreMonth();
    };
    const changeVendor = async () => {
      let vendorCountRO = {
        year: activityData.vendorFormData.year
      };
      let activityVendorCountVO = await getVendorCount(vendorCountRO);
      activityData.activityVendorCountData = activityVendorCountVO;
      await nextTick();
      if (activityData.vendorFormData.vendorId) {
        vendorChange(activityData.vendorFormData.vendorId);
      }
      refreshVendorChart();
    };
    const changeRepair = async () => {
      let repairCountRO = {
        year: activityData.repairFormData.year
      };
      let repairCountVO = await getRepairVendorCount(repairCountRO);
      await nextTick();
      repairRank.repairStoreRank.length = 0;
      repairRank.repairVendorRank.length = 0;
      repairRank.repairStoreRank.push(...repairCountVO.repairStoreRank);
      repairRank.repairVendorRank.push(...repairCountVO.repairVendorRank);
      let repairVendorCountData = [];
      let totalRepairVendorCount = 0;
      if (Array.isArray(repairCountVO.totalRepairVendorCount)) {
        totalRepairVendorCount = repairCountVO.totalRepairVendorCount.reduce((sum, item) => sum + item.quantity, 0);
        repairVendorCountData.push(...repairCountVO.totalRepairVendorCount);
      }
      drawPieChart("pieRepairVendorCountContent", "vendorName", "quantity", repairVendorCountData, totalRepairVendorCount);
      drawBarChart("barRepairVendorCountContent", repairVendorCountData);
    };
    const refreshStoreTypeCount = () => {
      activityData.filterActivityStoreTypeCount.length = 0;
      let otherStoreTypeCount = {
        storeTypeName: "Other",
        quantity: 0
      };
      let totalStoreTypeCount = {
        storeTypeName: "Total",
        quantity: 0
      };
      for (let storeTypeCount of activityData.activityStoreTypeCount) {
        if (activityData.activityFormData.storeTypeName.includes("All") || activityData.activityFormData.storeTypeName.includes(storeTypeCount.storeTypeName)) {
          activityData.filterActivityStoreTypeCount.push(storeTypeCount);
          totalStoreTypeCount.quantity += storeTypeCount.quantity;
        } else {
          totalStoreTypeCount.quantity += storeTypeCount.quantity;
          otherStoreTypeCount.quantity += storeTypeCount.quantity;
        }
      }
      activityData.filterActivityStoreTypeCount.unshift(totalStoreTypeCount);
      if (otherStoreTypeCount.quantity > 0) {
        activityData.filterActivityStoreTypeCount.push(otherStoreTypeCount);
      }
      for (let storeTypeCount of activityData.filterActivityStoreTypeCount) {
        if (totalStoreTypeCount.quantity > 0) {
          let percentage = storeTypeCount.quantity / totalStoreTypeCount.quantity * 100;
          storeTypeCount.percentage = parseFloat((Math.round(percentage * 100) / 100).toString());
        } else {
          storeTypeCount.percentage = 0;
        }
      }
    };
    const storeTypeChange = async (values, options) => {
      if (values != null && values.length > 1) {
        if (values[values.length - 1] === "All") {
          activityData.activityFormData.storeTypeName = activityData.activityFormData.storeTypeName.filter(item => item === "All");
        } else {
          activityData.activityFormData.storeTypeName = activityData.activityFormData.storeTypeName.filter(item => item !== "All");
        }
      }
      refreshStoreTypeCount();
    };
    const filterTopRank = () => {
      activityData.filterActivityStoreRankCount.length = 0;
      if (isTop50.value === true) {
        activityData.filterActivityStoreRankCount.push(...activityData.activityStoreRankCount.slice(0, 50));
      } else {
        activityData.filterActivityStoreRankCount.push(...activityData.activityStoreRankCount.slice(0, 100));
      }
    };
    const refreshLowActivityStore = activityStoreRankCount => {
      if (Array.isArray(activityStoreRankCount) && activityStoreRankCount.length > 0) {
        // 参与活动小于4次/年
        const lessThan4Count = activityStoreRankCount.filter(item => item.quantity < 4).length;
        activityData.lt4 = lessThan4Count;
        const greaterThanOrEqualTo4 = activityStoreRankCount.filter(item => item.quantity >= 4).length;
        activityData.gte4 = greaterThanOrEqualTo4;
        const oneYearAgo = dayjs().subtract(12, "month");
        // 一年内新开店
        const oneYearcount = activityStoreRankCount.filter(item => {
          const openingDate = dayjs(item.openingHours);
          return openingDate.isAfter(oneYearAgo) && item.quantity < 4;
        }).length;
        // 已关店
        const closeStoreCount = activityStoreRankCount.filter(item => item.quantity < 4 && item.storeStatusId === 4).length;
        // 未参与活动
        const notActivityCount = activityStoreRankCount.filter(item => item.storeStatusId === 0).length;
        // 参与活动数量 1-3次/年
        const lessThan1_3Count = activityStoreRankCount.filter(item => item.quantity < 4 && item.quantity > 0).length;
        let data = [];
        if (notActivityCount > 0) {
          data.push({
            title: "未参与活动",
            quantity: notActivityCount,
            exportType: 3
          });
        }
        if (closeStoreCount > 0) {
          data.push({
            title: "已关店",
            quantity: closeStoreCount,
            exportType: 2
          });
        }
        if (oneYearcount > 0) {
          data.push({
            title: "一年内新开店",
            quantity: oneYearcount,
            exportType: 1
          });
        }
        if (lessThan1_3Count > 0) {
          data.push({
            title: "参与活动数量 1-3次/年",
            quantity: lessThan1_3Count,
            exportType: 4
          });
        }
        const chartLessThan4 = new Chart({
          container: "lessThan4Content",
          autoFit: true
        });
        chartLessThan4.coordinate({
          type: "theta",
          outerRadius: 0.7,
          innerRadius: 0.4
        });
        chartLessThan4.interval().data(data).transform({
          type: "stackY"
        }) // 堆叠
        .encode("y", "quantity").encode("color", "title")
        // 给图例做颜色映射，用基准色即可（渐变只显示在扇区中，图例处显示单色）
        .scale("color", {
          type: "ordinal",
          range: data.map((_, i) => getBaseColor(i))
        }).animate("enter", {
          type: "waveIn",
          // 或者自定义
          duration: 1000,
          easing: "ease-out"
        }).style("fill", (_, i) => {
          // 每条记录的索引 i：生成一个渐变色
          const baseColor = getBaseColor(i);
          const lighterColor = lightenColor(baseColor, 0.4); // 调大 0.4 可使渐变更明显
          // 这里使用线性渐变，从左到右 (l(0))，你也可改成径向 (r(...))
          return `l(0) 0:${lighterColor} 1:${baseColor}`;
        })
        // 通过描边 + 线宽实现扇区之间的分割空隙
        .style("stroke", "#fff").style("lineWidth", 2)
        // 图例在底部居中
        .legend("color", {
          position: "bottom",
          layout: {
            justifyContent: "center"
          }
        })
        // 外侧标签显示百分比
        .label({
          position: "outside",
          text: d => `${d.title}: ${d.quantity}家`,
          offset: 25,
          // 增大 offset 避免重叠
          transform: [{
            type: "overlapDodgeY"
          }],
          style: {
            cursor: "pointer",
            // 设置鼠标悬停为手型
            fill: "#333",
            // 标签文字颜色
            fontSize: 12
          }
        })
        // 提示信息
        .tooltip(d => ({
          name: d.title,
          value: `${d.quantity}家`
        }));

        // 将事件监听绑定到图表实例（chartLessThan4）上
        chartLessThan4.on("label:click", event => {
          const data = event.data?.data;
          if (data) {
            let activityCountRO = {
              activityCategoryId: activityData.activityFormData.activityCategoryId,
              activityBegin: activityData.activityFormData.activityDateValue[0].format("YYYY-MM-DD"),
              activityEnd: activityData.activityFormData.activityDateValue[1].format("YYYY-MM-DD"),
              exportType: data.exportType
            };
            getActivityCountInRange1ToLessThan3Export(activityCountRO);
          }
        });
        chartLessThan4.text().style("x", "50%").style("y", "50%").style("fontSize", 21).style("fill", "#8c8c8c").style("textAlign", "center");
        chartLessThan4.legend(false);
        try {
          chartLessThan4.render();
        } catch (e) {
          console.log(e);
        }
      }
    };
    const top50Click = () => {
      isTop50.value = true;
      filterTopRank();
    };
    const top100Click = () => {
      isTop50.value = false;
      filterTopRank();
    };
    const onVendorTypeChange = val => {
      vendorTypeChange(val);
    };
    const vendorTypeChange = val => {
      let findIndex = activityData.vendorTypeVendorData.findIndex(element => element.vendorTypeId == val);
      if (findIndex != -1) {
        activityData.vendorFormData.vendorId = null;
        activityData.vendorData.length = 0;
        activityData.vendorData.push(...activityData.vendorTypeVendorData[findIndex].vendors);
      }
    };
    const onVendorChange = val => {
      vendorChange(val);
    };
    const vendorChange = val => {
      if (val) {
        let findIndex = activityData.activityVendorCountData.findIndex(element => element.vendorId == val);
        if (findIndex != -1) {
          let vendorCountData = activityData.activityVendorCountData[findIndex].vendorCountData;
          const data = [];
          const monthMap = {
            january: "01",
            february: "02",
            march: "03",
            april: "04",
            may: "05",
            june: "06",
            july: "07",
            august: "08",
            september: "09",
            october: "10",
            november: "11",
            december: "12"
          };
          vendorCountData.forEach((obj, index) => {
            Object.entries(obj).forEach(([month, complete]) => {
              data.push({
                month: activityData.vendorFormData.year + "-" + monthMap[month.toLowerCase()],
                complete: complete.toString(),
                type: index === 0 ? "安装完成率" : "运输完成率"
              });
            });
          });
          for (let i = 0; i < 2; i++) {
            const vendorCompleteChart = new Chart({
              container: i === 0 ? "vendorCompleteInstall" : "vendorCompleteLogistics",
              autoFit: true
            });
            vendorCompleteChart.data(i === 0 ? data.filter(item => item.type === "安装完成率" && item.complete !== "0") : data.filter(item => item.type === "运输完成率" && item.complete !== "0")).encode("x", "month").encode("y", "complete").encode("color", "type").scale("x", {
              range: [0, 1]
            }).scale("y", {
              domain: [0, 100],
              // 指定最小最大区间
              ticks: [0, 25, 50, 75, 100],
              // 显式指定刻度
              nice: false
            }).scale("color", {
              domain: ["安装完成率", "运输完成率"],
              range: ["#00DD00", "#2D6BCA"]
            });

            // 新增坐标轴网格线配置
            vendorCompleteChart.axis("x", {
              grid: true,
              labelFontSize: 10,
              title: null,
              gridStroke: "#000",
              // 修改颜色
              gridLineWidth: 1,
              gridLineDash: [0, 0] // 改为实线（移除虚线样式）
            });

            vendorCompleteChart.axis("y", {
              grid: true,
              labelFontSize: 10,
              title: null,
              gridStroke: "#000",
              // 修改颜色
              gridLineWidth: 1,
              gridLineDash: [0, 0],
              labelFormatter: d => d + "%"
            });

            // 绘制折线
            vendorCompleteChart.line().label({
              text: "",
              style: {
                dx: -10,
                dy: -12,
                fill: "#333"
              }
            });

            // 绘制数据点
            vendorCompleteChart.point().style("fill", "white").style("lineWidth", 2).tooltip(false);
            vendorCompleteChart.legend(false);
            try {
              vendorCompleteChart.render();
            } catch (e) {
              console.log(e);
            }
          }
        }
      }
    };
    const isVendorActivityClick = () => {
      isVendorActivity.value = true;
      refreshVendorChart();
    };
    const isVendorLocationClick = () => {
      isVendorActivity.value = false;
      refreshVendorChart();
    };
    const refreshVendorChart = () => {
      let vendorCountData = [{
        vendorTypeId: 1,
        quantity: 0,
        data: []
      }, {
        vendorTypeId: 2,
        quantity: 0,
        data: []
      }, {
        vendorTypeId: 4,
        quantity: 0,
        data: []
      }];
      if (Array.isArray(activityData.activityVendorCountData) && activityData.activityVendorCountData.length > 0) {
        for (let vendor of activityData.activityVendorCountData) {
          let findIndex = vendorCountData.findIndex(element => element.vendorTypeId == vendor.vendorTypeId);
          if (findIndex != -1) {
            let targetQuantity = vendor.activityQuantity;
            if (isVendorActivity.value === false) {
              targetQuantity = vendor.locationQuantity;
            }
            vendorCountData[findIndex].quantity += targetQuantity;
            let findIndexData = vendorCountData[findIndex].data.findIndex(element => element.vendorName == vendor.vendorName);
            if (findIndexData != -1) {
              vendorCountData[findIndex].data[findIndexData].quantity += targetQuantity;
            } else {
              vendorCountData[findIndex].data.push({
                vendorName: vendor.vendorName,
                quantity: targetQuantity
              });
            }
          }
        }
      }
      for (let vendorCount of vendorCountData) {
        for (let vendorCountItem of vendorCount.data) {
          vendorCountItem.percent = vendorCount.quantity === 0 ? 0 : Math.round(vendorCountItem.quantity / vendorCount.quantity * 100) / 100;
        }
      }
      drawVendorChart("vendorImagery", vendorCountData[0]);
      drawVendorChart("vendorProps", vendorCountData[1]);
      if (vendorCountData[2].quantity > 0) {
        drawVendorChart("vendorProgram", vendorCountData[2]);
      }
    };
    const drawVendorChart = (id, vendorData) => {
      const data = vendorData.data;
      const chartVendorProps = new Chart({
        container: id,
        autoFit: true
      });
      chartVendorProps.coordinate({
        type: "theta",
        outerRadius: 0.8,
        innerRadius: 0.5
      });
      chartVendorProps.interval().data(data).transform({
        type: "stackY"
      }) // 堆叠
      .encode("y", "percent").encode("color", "vendorName")
      // 给图例做颜色映射，用基准色即可（渐变只显示在扇区中，图例处显示单色）
      .scale("color", {
        type: "ordinal",
        range: data.map((_, i) => getBaseColor(i))
      }).animate("enter", {
        type: "waveIn",
        // 或者自定义
        duration: 1000,
        easing: "ease-out"
      }).style("fill", (_, i) => {
        // 每条记录的索引 i：生成一个渐变色
        const baseColor = getBaseColor(i);
        const lighterColor = lightenColor(baseColor, 0.4); // 调大 0.4 可使渐变更明显
        // 这里使用线性渐变，从左到右 (l(0))，你也可改成径向 (r(...))
        return `l(0) 0:${lighterColor} 1:${baseColor}`;
      })
      // 通过描边 + 线宽实现扇区之间的分割空隙
      .style("stroke", "#fff").style("lineWidth", 2)
      // 图例在底部居中
      .legend("color", {
        position: "bottom",
        layout: {
          justifyContent: "center"
        }
      })
      // 外侧标签显示百分比
      .label({
        position: "outside",
        text: d => `${d.vendorName}: ${(d.percent * 100).toFixed(0)}%`
      })
      // 提示信息
      .tooltip(d => ({
        name: d.item,
        value: `${(d.percent * 100).toFixed(0)}%`
      }));
      chartVendorProps.text().style("text", vendorData.quantity.toString()).style("x", "50%").style("y", "50%").style("fontSize", 21).style("fill", "#8c8c8c").style("textAlign", "center").tooltip(false);
      chartVendorProps.legend(false);
      try {
        chartVendorProps.render();
      } catch (e) {
        console.log(e);
      }
    };

    // 一个简单的色板，如果数据超过色板长度，就循环取
    const getBaseColor = index => {
      const colorPalette = ["#9B6BF5",
      // 柔和紫
      "#FFA86A",
      // 橙
      "#65C6F7",
      // 浅蓝
      "#FF7EA6",
      // 粉
      "#40D6CB",
      // 浅青
      "#B2A4F4",
      // 浅紫
      "#FFC297",
      // 浅橙
      "#8ED6F8",
      // 浅蓝（比上面略更淡一些）
      "#FFAFC2",
      // 另一种粉
      "#7FE7DD" // 另一种浅青
      ];

      return colorPalette[index % colorPalette.length];
    };

    // 将指定 hex 颜色根据 ratio (0~1) 调亮
    // ratio=0 不变，ratio=1 则变成纯白
    const lightenColor = (hex, ratio) => {
      hex = hex.replace(/^#/, "");
      let r = parseInt(hex.substring(0, 2), 16);
      let g = parseInt(hex.substring(2, 4), 16);
      let b = parseInt(hex.substring(4, 6), 16);
      r += Math.round((255 - r) * ratio);
      g += Math.round((255 - g) * ratio);
      b += Math.round((255 - b) * ratio);
      if (r > 255) r = 255;
      if (g > 255) g = 255;
      if (b > 255) b = 255;
      const rr = (r < 16 ? "0" : "") + r.toString(16);
      const gg = (g < 16 ? "0" : "") + g.toString(16);
      const bb = (b < 16 ? "0" : "") + b.toString(16);
      return "#" + rr + gg + bb;
    };
    const drawPieChart = (id, x, y, data, center, suffix) => {
      let chartPie = new Chart({
        container: id,
        autoFit: true
      });
      chartPie.coordinate({
        type: "theta",
        outerRadius: 0.8,
        innerRadius: 0.5
      });
      chartPie.interval().data(data).transform({
        type: "stackY"
      }) // 堆叠
      .encode("y", y).encode("color", x)
      // 给图例做颜色映射，用基准色即可（渐变只显示在扇区中，图例处显示单色）
      .scale("color", {
        type: "ordinal",
        range: data.map((_, i) => getBaseColor(i))
      }).style("fill", (_, i) => {
        // 每条记录的索引 i：生成一个渐变色
        const baseColor = getBaseColor(i);
        const lighterColor = lightenColor(baseColor, 0.4); // 调大 0.4 可使渐变更明显
        // 这里使用线性渐变，从左到右 (l(0))，你也可改成径向 (r(...))
        return `l(0) 0:${lighterColor} 1:${baseColor}`;
      })
      // 通过描边 + 线宽实现扇区之间的分割空隙
      .style("stroke", "#fff").style("lineWidth", 2)
      // 图例在底部居中
      .legend("color", {
        position: "bottom",
        layout: {
          justifyContent: "center"
        }
      })
      // 外侧标签显示百分比
      .label({
        position: "outside",
        text: d => `${d[x]}: ${d[y].toFixed(0)}${suffix == null ? "" : suffix}`
      })
      // 提示信息
      .tooltip(d => ({
        name: d.item,
        value: `${d[y].toFixed(0)}${suffix == null ? "" : suffix}`
      }));
      chartPie.text().style("text", center.toString()).style("x", "50%").style("y", "50%").style("fontSize", 21).style("fill", "#8c8c8c").style("textAlign", "center").tooltip(false);
      chartPie.legend(false);
      try {
        chartPie.render();
      } catch (e) {
        console.log(e);
      }
      return chartPie;
    };
    const drawBarChart = (id, data, suffix) => {
      let chartBar = new Chart({
        container: id,
        autoFit: true
      });
      const maxQuantity = data.reduce((max, item) => Math.max(max, Number(item.quantity) || -Infinity), -Infinity);
      chartBar.interval().data(data).encode("x", "vendorName").encode("y", "quantity").encode("size", 24).axis("x", {
        labelFill: "black",
        labelFontSize: 10,
        title: null
      }).axis("y", {
        labelFill: "black",
        labelFontSize: 10,
        title: null,
        labelFormatter: d => suffix == null ? d : d + suffix
      }).scale("x", {
        range: [0, 0.5]
      }).scale("y", {
        nice: true,
        tickCount: maxQuantity > 5 ? maxQuantity + 1 : 6,
        domain: [0, maxQuantity > 5 ? maxQuantity : 5]
      }).style("fill", (_, i) => {
        // 每条记录的索引 i：生成一个渐变色
        const baseColor = getBaseColor(i);
        const lighterColor = lightenColor(baseColor, 0.4); // 调大 0.4 可使渐变更明显
        // 这里使用线性渐变，从左到右 (l(0))，你也可改成径向 (r(...))
        return `l(90) 0:${lighterColor} 1:${baseColor}`;
      }).tooltip(d => ({
        name: d.item,
        value: `${d.quantity.toFixed(0)}${suffix == null ? "" : suffix}`
      }));
      try {
        chartBar.render();
      } catch (e) {
        console.log(e);
      }
      return chartBar;
    };
    const categoryClick = value => {
      storeTypeControl.activityCategoryId = value;
      changeStore();
    };
    const storeTypeNameClick = value => {
      const index = storeTypeControl.selectedStoreTypeName.indexOf(value);
      let removeTypeName = null;
      if (index === -1) {
        storeTypeControl.selectedStoreTypeName.push(value);
      } else {
        removeTypeName = storeTypeControl.selectedStoreTypeName[index];
        storeTypeControl.selectedStoreTypeName.splice(index, 1);
      }
      debugger;
      storeTypeControl.filterStoreType.length = 0;
      for (let storeType of storeTypeControl.filterStoreTypeFullData) {
        if (storeTypeControl.selectedStoreTypeName.includes(storeType.storeTypeName)) {
          storeTypeControl.filterStoreType.push(storeType);
        }
      }
      if (index !== -1) {
        let removeStoreTypeIds = storeTypeControl.filterStoreTypeFullData.filter(item => item.storeTypeName === removeTypeName).map(item => item.storeTypeId);
        storeTypeControl.storeTypeIds = storeTypeControl.storeTypeIds.filter(id => !removeStoreTypeIds.includes(id));
      }
      // storeTypeControl.storeTypeIds.length = 0;
      // storeTypeControl.storeTypeIds.push(
      //   storeTypeControl.filterStoreType[0].storeTypeId
      // );
      activityStoreMonth();
    };
    const storeTypeFullClick = value => {
      const index = storeTypeControl.storeTypeIds.indexOf(value);
      if (index !== -1) {
        storeTypeControl.storeTypeIds.splice(index, 1);
      } else {
        storeTypeControl.storeTypeIds.push(value);
      }
      activityStoreMonth();
    };
    const formatDateToDayMonth = dateStr => {
      const date = new Date(dateStr);
      const day = date.getDate();
      const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
      const month = monthNames[date.getMonth()];

      // 获取序数词后缀
      const getOrdinalSuffix = n => {
        if (n >= 11 && n <= 13) return n + "th";
        switch (n % 10) {
          case 1:
            return n + "st";
          case 2:
            return n + "nd";
          case 3:
            return n + "rd";
          default:
            return n + "th";
        }
      };
      return `${getOrdinalSuffix(day)} ${month}`;
    };
    const activityStoreMonth = () => {
      const activityStoreMonthCountVO = activityData.activityStoreMonthCountData.filter(item => storeTypeControl.storeTypeIds.includes(item.storeTypeId));
      if (Array.isArray(activityStoreMonthCountVO) && activityStoreMonthCountVO.length > 0) {
        selectedActivity.data = activityStoreMonthCountVO[activityStoreMonthCountVO.length - 1];
      }
      let filterMonth = {};
      let maxTicks = 0;
      let monthNames = {};
      let ticksIndex = 0;
      if (Array.isArray(activityStoreMonthCountVO) && activityStoreMonthCountVO.length > 0) {
        const countMap = activityStoreMonthCountVO.reduce((map, item) => {
          const key = item.month;
          map[key] = (map[key] || 0) + 1;
          return map;
        }, {});
        maxTicks = Math.max(...Object.values(countMap));
        let lastMonthNode = null;
        for (let activityStoreMonth of activityStoreMonthCountVO) {
          if (filterMonth[activityStoreMonth.month]) {
            filterMonth[activityStoreMonth.month]++;
            activityStoreMonth.monthName = activityStoreMonth.month + "_" + filterMonth[activityStoreMonth.month].toString();
            ticksIndex++;
            activityStoreMonth.ticksIndex = ticksIndex;
            lastMonthNode = activityStoreMonth.month;
          } else {
            if (lastMonthNode != null) {
              ticksIndex += maxTicks - filterMonth[lastMonthNode] + 1;
            } else {
              ticksIndex++;
            }
            monthNames[ticksIndex] = activityStoreMonth.month;
            filterMonth[activityStoreMonth.month] = 1;
            activityStoreMonth.ticksIndex = ticksIndex;
            activityStoreMonth.monthName = "@" + activityStoreMonth.month + "_" + filterMonth[activityStoreMonth.month].toString();
            lastMonthNode = activityStoreMonth.month;
          }
        }
      }
      const chart = new Chart({
        container: "storeActivityContainer",
        autoFit: true
      });
      chart.data(activityStoreMonthCountVO).encode("x", "ticksIndex").encode("y", "quantity").encode("color", "storeTypeNameZh").scale("x", {
        domainMin: 1,
        nice: false,
        tickCount: ticksIndex
      }).axis("x", {
        title: null
      }).scale("y", {
        domainMin: 0,
        nice: true
      }).axis("y", {
        title: null
      });
      chart.legend("color", {
        itemMarker: "square",
        itemMarkerSize: 12,
        itemNameFontSize: 12,
        itemNameFill: "#000"
      });
      chart.options({
        tooltip: {
          domStyles: {
            "g2-tooltip": {
              padding: "0px"
            }
          }
        },
        interaction: {
          tooltip: {
            crosshairs: true,
            // 启用十字辅助线
            crosshairsLineDash: [4, 4],
            // 辅助线为虚线样式
            markerType: "hollow",
            css: {
              ".g2-tooltip": {
                padding: "0px"
              }
            },
            render: (event, {
              title,
              items
            }) => {
              return `<div style="background-color:#3E85FF;color:#FFF;font-size:12px;display:flex;flex-direction: column;padding:5px">
        ${items.map(({
                color,
                name,
                value
              }) => {
                const result = activityStoreMonthCountVO.find(item => item.ticksIndex === parseInt(title));
                if (result) {
                  return `
              <div>
                &#x1F552;&nbsp;${formatDateToDayMonth(result.activityBegin)}
              </div>
              <div>
                参与店铺数量: ${value}
              </div>
              <div>
                ${result.activityWeekName == null ? "" : result.activityWeekName + (result.activityYear + "").substring(2, 4) + result.activityName}
              </div>`;
                }
              }).join("")}
          </div>`;
            }
          }
        }
      });
      chart.line().label({
        text: "",
        style: {
          dx: -10,
          dy: -12
        }
      });
      chart.axis("x", {
        labelFormatter: (datum, index, data) => {
          if (monthNames[datum]) {
            return monthNames[datum];
          }
          return "";
        },
        labelTransform: []
      });
      chart.point().style("fill", "white").tooltip(false);
      chart.on("tooltip:show", ev => {
        hoverData = ev.data;
      });
      chart.on("plot:click", ev => {
        const result = activityStoreMonthCountVO.find(item => item.ticksIndex === parseInt(hoverData.title));
        selectedActivity.data = result;
        console.log(result);
      });

      // chart.tooltip({
      //   custom: true,
      //   enterable: true,
      //   domStyles: {
      //     "g2-tooltip": {
      //       padding: "12px",
      //     },
      //   },
      //   render: (items) => {
      //     // items 是 [{ name, value, ... }]
      //     return `<div style="font-size: 14px">
      //   <div><strong>${items[0].activityName}</strong>: ${items[0].quantity}</div>
      //   <div style="color: gray">我可以加备注、图标、超链接</div>
      // </div>`;
      //   },
      // });
      try {
        chart.render();
      } catch (e) {
        console.log(e);
      }
    };
    return (_ctx, _cache) => {
      const _component_a_select_option = _resolveComponent("a-select-option");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_range_picker = _resolveComponent("a-range-picker");
      const _component_a_tab_pane = _resolveComponent("a-tab-pane");
      const _component_vxe_column = _resolveComponent("vxe-column");
      const _component_vxe_table = _resolveComponent("vxe-table");
      const _component_a_config_provider = _resolveComponent("a-config-provider");
      const _component_a_tabs = _resolveComponent("a-tabs");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_a_config_provider, {
        theme: {
          components: {
            Tabs: {
              fontSize: 18,
              colorPrimary: '#777777',
              colorText: '#C4C4C4',
              motionDurationMid: 0,
              motionDurationSlow: 0
            }
          }
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_a_tabs, {
          class: "sts-tabs default",
          activeKey: activeTabsKey.value,
          "onUpdate:activeKey": _cache[8] || (_cache[8] = $event => activeTabsKey.value = $event),
          type: "card",
          animated: false,
          onChange: changeTab
        }, {
          default: _withCtx(() => [_createVNode(_component_a_tab_pane, {
            key: "1",
            tab: "活动信息"
          }, {
            default: _withCtx(() => [activeTabsKey.value === '1' ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_a_select, {
              value: activityData.activityFormData.activityCategoryId,
              "onUpdate:value": _cache[0] || (_cache[0] = $event => activityData.activityFormData.activityCategoryId = $event),
              placeholder: _ctx.$t('activityCreate.select'),
              onChange: pickerChange,
              size: "middle",
              style: {
                "min-width": "125px",
                "height": "39px",
                "margin-right": "19px"
              }
            }, {
              suffixIcon: _withCtx(() => [_createVNode(_unref(DownCircleOutlined), {
                class: "ant-select-suffix",
                style: {
                  "color": "#818181"
                }
              })]),
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityData.activityCategoryList, (item, index) => {
                return _openBlock(), _createBlock(_component_a_select_option, {
                  key: index,
                  value: item.activityCategoryId
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(item.activityCategoryName), 1)]),
                  _: 2
                }, 1032, ["value"]);
              }), 128))]),
              _: 1
            }, 8, ["value", "placeholder"]), _createVNode(_component_a_range_picker, {
              value: activityData.activityFormData.activityDateValue,
              "onUpdate:value": _cache[1] || (_cache[1] = $event => activityData.activityFormData.activityDateValue = $event),
              placeholder: [_ctx.$t('activityCreate.startTime'), _ctx.$t('activityCreate.endTime')],
              onChange: pickerChange,
              style: {
                "min-width": "265px",
                "height": "38px"
              }
            }, {
              suffixIcon: _withCtx(() => [_createVNode(_unref(DownCircleOutlined), {
                class: "ant-select-suffix",
                style: {
                  "color": "#818181",
                  "font-size": "24px"
                }
              })]),
              _: 1
            }, 8, ["value", "placeholder"]), _createVNode(_unref(Divider), {
              style: {
                "margin": "10px 10px",
                "flex": "1",
                "width": "auto",
                "min-width": "auto",
                "border-color": "rgb(215, 215, 215)"
              }
            })]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_hoisted_8, _createVNode(_unref(Divider), {
              style: {
                "margin": "10px",
                "flex": "1 1 0%",
                "width": "auto",
                "min-width": "auto",
                "border-color": "rgb(215, 215, 215)"
              }
            })]), _hoisted_9]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_hoisted_12, _createVNode(_component_a_select, {
              onChange: storeTypeChange,
              mode: "multiple",
              "max-tag-count": 6,
              value: activityData.activityFormData.storeTypeName,
              "onUpdate:value": _cache[2] || (_cache[2] = $event => activityData.activityFormData.storeTypeName = $event),
              placeholder: _ctx.$t('activityCreate.select'),
              size: "middle",
              style: {
                "min-width": "125px",
                "height": "39px",
                "margin-left": "18px"
              }
            }, {
              suffixIcon: _withCtx(() => [_createVNode(_unref(DownCircleOutlined), {
                class: "ant-select-suffix",
                style: {
                  "color": "#818181"
                }
              })]),
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityData.storeTypeData, (item, index) => {
                return _openBlock(), _createBlock(_component_a_select_option, {
                  key: index,
                  value: item
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(item), 1)]),
                  _: 2
                }, 1032, ["value"]);
              }), 128))]),
              _: 1
            }, 8, ["value", "placeholder"]), _createVNode(_unref(Divider), {
              style: {
                "margin": "10px",
                "flex": "1 1 0%",
                "width": "auto",
                "min-width": "auto",
                "border-color": "rgb(215, 215, 215)"
              }
            })]), _createElementVNode("div", _hoisted_13, [_hoisted_14, _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityData.filterActivityStoreTypeCount, (item, index) => {
              return _openBlock(), _createElementBlock("div", {
                key: index,
                style: {
                  "display": "flex",
                  "flex-direction": "column",
                  "align-items": "center",
                  "margin": "0px 15px"
                }
              }, [_createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, _toDisplayString(item.quantity), 1), _createElementVNode("div", _hoisted_19, " (" + _toDisplayString(item.percentage) + "%) ", 1)]), _createElementVNode("div", _hoisted_20, _toDisplayString(item.storeTypeName), 1)]);
            }), 128))])]), _hoisted_21]), _createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, _toDisplayString(activityData.gte4), 1), _hoisted_25, _hoisted_26, _createElementVNode("div", _hoisted_27, [_createElementVNode("div", {
              class: _normalizeClass([{
                active: isTop50.value
              }, "filter-button left"]),
              onClick: top50Click
            }, " TOP50 ", 2), _createElementVNode("div", {
              class: _normalizeClass([{
                active: isTop50.value === false
              }, "filter-button right"]),
              onClick: top100Click
            }, " TOP100 ", 2)]), _createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityData.filterActivityStoreRankCount, (item, index) => {
              return _openBlock(), _createElementBlock("div", {
                key: index,
                style: _normalizeStyle([{
                  "display": "flex",
                  "font-size": "13px",
                  "height": "30px",
                  "min-height": "30px",
                  "align-items": "center",
                  "color": "#777777",
                  "padding-right": "10px"
                }, {
                  backgroundColor: (index + 1) % 2 === 0 ? '#f7f7f7' : '#ffffff'
                }])
              }, [_createElementVNode("div", _hoisted_30, _toDisplayString(index + 1 + ". " + item.storeName), 1), _createElementVNode("div", _hoisted_31, _toDisplayString(item.quantity), 1)], 4);
            }), 128))])])]), _createElementVNode("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, _toDisplayString(activityData.lt4), 1), _hoisted_34, _hoisted_35, _hoisted_36])])])])])) : _createCommentVNode("", true)]),
            _: 1
          }), _createVNode(_component_a_tab_pane, {
            key: "2",
            tab: "店铺数据"
          }, {
            default: _withCtx(() => [activeTabsKey.value === '2' ? (_openBlock(), _createElementBlock("div", _hoisted_37, [_createElementVNode("div", _hoisted_38, [_createVNode(_component_a_range_picker, {
              value: activityData.storeFormData.activityDateValue,
              "onUpdate:value": _cache[3] || (_cache[3] = $event => activityData.storeFormData.activityDateValue = $event),
              placeholder: [_ctx.$t('activityCreate.startTime'), _ctx.$t('activityCreate.endTime')],
              onChange: changeStore,
              style: {
                "min-width": "265px",
                "height": "38px"
              }
            }, {
              suffixIcon: _withCtx(() => [_createVNode(_unref(DownCircleOutlined), {
                class: "ant-select-suffix",
                style: {
                  "color": "#818181",
                  "font-size": "24px"
                }
              })]),
              _: 1
            }, 8, ["value", "placeholder"]), _createVNode(_unref(Divider), {
              style: {
                "margin": "10px 10px",
                "flex": "1",
                "width": "auto",
                "min-width": "auto",
                "border-color": "rgb(215, 215, 215)"
              }
            })]), _createElementVNode("div", _hoisted_39, [_createElementVNode("div", _hoisted_40, [_createElementVNode("div", _hoisted_41, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityData.activityCategoryList, (item, index) => {
              return _openBlock(), _createElementBlock("div", {
                key: index,
                class: _normalizeClass([{
                  active: item.activityCategoryId === storeTypeControl.activityCategoryId
                }, "filter-button-float"]),
                onClick: $event => categoryClick(item.activityCategoryId)
              }, _toDisplayString(item.activityCategoryName.toUpperCase()), 11, _hoisted_42);
            }), 128))]), _createVNode(_unref(Divider), {
              style: {
                "border-color": "rgb(215, 215, 215)"
              }
            }), _createElementVNode("div", _hoisted_43, [_createElementVNode("div", _hoisted_44, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(storeTypeControl.filterStoreTypeData, (item, index) => {
              return _openBlock(), _createElementBlock("div", {
                key: index,
                class: _normalizeClass([{
                  active: storeTypeControl.selectedStoreTypeName.includes(item)
                }, "filter-button-float"]),
                onClick: $event => storeTypeNameClick(item)
              }, _toDisplayString(item), 11, _hoisted_45);
            }), 128))])]), _createVNode(_unref(Divider), {
              style: {
                "border-color": "rgb(215, 215, 215)"
              }
            }), _createElementVNode("div", _hoisted_46, [_createElementVNode("div", _hoisted_47, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(storeTypeControl.filterStoreType, (item, index) => {
              return _openBlock(), _createElementBlock("div", {
                key: index,
                class: _normalizeClass([{
                  active: storeTypeControl.storeTypeIds.includes(item.storeTypeId)
                }, "filter-button-float"]),
                onClick: $event => storeTypeFullClick(item.storeTypeId)
              }, _toDisplayString(item.storeTypeNameZh), 11, _hoisted_48);
            }), 128))])])]), selectedActivity.data.uploadedName ? (_openBlock(), _createElementBlock("div", _hoisted_49, [_createVNode(_unref(Divider), {
              style: {
                "height": "100%",
                "margin": "0px 15px",
                "border-color": "rgb(215, 215, 215)"
              },
              type: "vertical"
            }), _createElementVNode("img", {
              style: {
                "width": "346px",
                "height": "185px"
              },
              src: selectedActivity.data.uploadedName
            }, null, 8, _hoisted_50), _createElementVNode("div", _hoisted_51, [_createElementVNode("div", _hoisted_52, [_createElementVNode("div", _hoisted_53, _toDisplayString(selectedActivity.data.activityName), 1)]), _createElementVNode("div", _hoisted_54, _toDisplayString(selectedActivity.data.activityBegin) + " 一 " + _toDisplayString(selectedActivity.data.activityEnd), 1), _createElementVNode("div", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedActivity.data.tags, (x, index) => {
              return _openBlock(), _createElementBlock("span", {
                style: {
                  "color": "#0763db",
                  "font-size": "13.5px",
                  "margin-right": "20px"
                },
                key: index
              }, " #" + _toDisplayString(x.activityTagNameZh), 1);
            }), 128))]), _createElementVNode("div", _hoisted_55, [_hoisted_56, _createElementVNode("div", _hoisted_57, _toDisplayString(selectedActivity.data.activityDescription), 1)])])])) : _createCommentVNode("", true)]), _hoisted_58])) : _createCommentVNode("", true)]),
            _: 1
          }), _createVNode(_component_a_tab_pane, {
            key: "3",
            tab: "供应商数据"
          }, {
            default: _withCtx(() => [activeTabsKey.value === '3' ? (_openBlock(), _createElementBlock("div", _hoisted_59, [_createElementVNode("div", _hoisted_60, [_createVNode(_component_a_select, {
              onChange: changeVendor,
              "max-tag-count": 6,
              value: activityData.vendorFormData.year,
              "onUpdate:value": _cache[4] || (_cache[4] = $event => activityData.vendorFormData.year = $event),
              placeholder: _ctx.$t('activityCreate.select'),
              size: "middle",
              style: {
                "min-width": "125px",
                "height": "39px"
              }
            }, {
              suffixIcon: _withCtx(() => [_createVNode(_unref(DownCircleOutlined), {
                class: "ant-select-suffix",
                style: {
                  "color": "#818181"
                }
              })]),
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityData.yearOptions, (item, index) => {
                return _openBlock(), _createBlock(_component_a_select_option, {
                  key: index,
                  value: item
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(item), 1)]),
                  _: 2
                }, 1032, ["value"]);
              }), 128))]),
              _: 1
            }, 8, ["value", "placeholder"]), _createVNode(_unref(Divider), {
              style: {
                "margin": "10px",
                "flex": "1 1 0%",
                "width": "auto",
                "min-width": "auto",
                "border-color": "rgb(215, 215, 215)"
              }
            })]), _createElementVNode("div", _hoisted_61, [_hoisted_62, _createVNode(_component_a_select, {
              onChange: onVendorTypeChange,
              value: activityData.vendorFormData.vendorTypeId,
              "onUpdate:value": _cache[5] || (_cache[5] = $event => activityData.vendorFormData.vendorTypeId = $event),
              placeholder: _ctx.$t('activityCreate.select'),
              size: "middle",
              options: vendorTypeData,
              style: {
                "min-width": "125px",
                "height": "39px",
                "margin-left": "18px"
              }
            }, {
              suffixIcon: _withCtx(() => [_createVNode(_unref(DownCircleOutlined), {
                class: "ant-select-suffix",
                style: {
                  "color": "#818181"
                }
              })]),
              _: 1
            }, 8, ["value", "placeholder"]), _createVNode(_component_a_select, {
              onChange: onVendorChange,
              value: activityData.vendorFormData.vendorId,
              "onUpdate:value": _cache[6] || (_cache[6] = $event => activityData.vendorFormData.vendorId = $event),
              placeholder: _ctx.$t('activityCreate.select'),
              size: "middle",
              style: {
                "min-width": "125px",
                "height": "39px",
                "margin-left": "18px"
              }
            }, {
              suffixIcon: _withCtx(() => [_createVNode(_unref(DownCircleOutlined), {
                class: "ant-select-suffix",
                style: {
                  "color": "#818181"
                }
              })]),
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityData.vendorData, (item, index) => {
                return _openBlock(), _createBlock(_component_a_select_option, {
                  key: index,
                  value: item.vendorId
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(item.vendorName), 1)]),
                  _: 2
                }, 1032, ["value"]);
              }), 128))]),
              _: 1
            }, 8, ["value", "placeholder"]), _createVNode(_unref(Divider), {
              style: {
                "margin": "10px",
                "flex": "1 1 0%",
                "width": "auto",
                "min-width": "auto",
                "border-color": "rgb(215, 215, 215)"
              }
            })]), _hoisted_63, _hoisted_64, _createElementVNode("div", _hoisted_65, [_hoisted_66, _createElementVNode("div", _hoisted_67, [_createElementVNode("div", {
              class: _normalizeClass([{
                active: isVendorActivity.value
              }, "filter-button left"]),
              onClick: isVendorActivityClick
            }, " 活动数量 ", 2), _createElementVNode("div", {
              class: _normalizeClass([{
                active: isVendorActivity.value === false
              }, "filter-button right"]),
              onClick: isVendorLocationClick
            }, " 点位数量 ", 2)]), _createVNode(_unref(Divider), {
              style: {
                "margin": "10px",
                "flex": "1 1 0%",
                "width": "auto",
                "min-width": "auto",
                "border-color": "rgb(215, 215, 215)"
              }
            })]), _hoisted_68])) : _createCommentVNode("", true)]),
            _: 1
          }), _createVNode(_component_a_tab_pane, {
            key: "4",
            tab: "报修数据"
          }, {
            default: _withCtx(() => [activeTabsKey.value === '4' ? (_openBlock(), _createElementBlock("div", _hoisted_69, [_createElementVNode("div", _hoisted_70, [_createVNode(_component_a_select, {
              onChange: changeRepair,
              "max-tag-count": 6,
              value: activityData.repairFormData.year,
              "onUpdate:value": _cache[7] || (_cache[7] = $event => activityData.repairFormData.year = $event),
              placeholder: _ctx.$t('activityCreate.select'),
              size: "middle",
              style: {
                "min-width": "125px",
                "height": "39px"
              }
            }, {
              suffixIcon: _withCtx(() => [_createVNode(_unref(DownCircleOutlined), {
                class: "ant-select-suffix",
                style: {
                  "color": "#818181"
                }
              })]),
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityData.yearOptions, (item, index) => {
                return _openBlock(), _createBlock(_component_a_select_option, {
                  key: index,
                  value: item
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(item), 1)]),
                  _: 2
                }, 1032, ["value"]);
              }), 128))]),
              _: 1
            }, 8, ["value", "placeholder"]), _createVNode(_unref(Divider), {
              style: {
                "margin": "10px",
                "flex": "1 1 0%",
                "width": "auto",
                "min-width": "auto",
                "border-color": "rgb(215, 215, 215)"
              }
            })]), _hoisted_71, _hoisted_72, _createVNode(_unref(Divider), {
              style: {
                "width": "auto",
                "min-width": "auto",
                "border-color": "rgb(215, 215, 215)"
              }
            }), _createElementVNode("div", _hoisted_73, [_createElementVNode("div", _hoisted_74, [_createVNode(_component_a_config_provider, {
              theme: {
                components: {
                  Button: {
                    controlHeight: 24
                  }
                }
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_vxe_table, {
                stripe: "",
                height: "auto",
                data: repairRank.repairStoreRank,
                ref: "activityStatsItemTable",
                class: "sts-table",
                "show-overflow": "",
                border: 'none'
              }, {
                default: _withCtx(() => [_createVNode(_component_vxe_column, {
                  field: "name",
                  title: "店铺名称",
                  sortable: ""
                }), _createVNode(_component_vxe_column, {
                  field: "quantity",
                  title: "报修次数",
                  sortable: "",
                  width: "150"
                })]),
                _: 1
              }, 8, ["data"])]),
              _: 1
            })]), _createElementVNode("div", _hoisted_75, [_createVNode(_component_a_config_provider, {
              theme: {
                components: {
                  Button: {
                    controlHeight: 24
                  }
                }
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_vxe_table, {
                stripe: "",
                height: "auto",
                data: repairRank.repairVendorRank,
                ref: "activityStatsItemTable",
                class: "sts-table",
                "show-overflow": "",
                border: 'none'
              }, {
                default: _withCtx(() => [_createVNode(_component_vxe_column, {
                  field: "name",
                  title: "供应商名称",
                  sortable: ""
                }), _createVNode(_component_vxe_column, {
                  field: "quantity",
                  title: "平均维修周期(天)",
                  sortable: "",
                  width: "300"
                })]),
                _: 1
              }, 8, ["data"])]),
              _: 1
            })])])])) : _createCommentVNode("", true)]),
            _: 1
          })]),
          _: 1
        }, 8, ["activeKey"])]),
        _: 1
      })])]);
    };
  }
};